import $ from 'jquery'
import slick from 'slick-carousel'
import velocity from 'velocity-animate'
import page from 'page.js'

import 'fullpage.js/vendors/scrolloverflow'
import fullpage from 'fullpage.js'

// require ('./plugins/fullpage.js')

// require('jquery-mousewheel')
// import GMaps from 'gmaps'
//import disableScroll from 'disable-scroll'



//import Hammer from 'hammerjs'

var imagesLoaded = require('imagesLoaded')
imagesLoaded.makeJQueryPlugin( $ )


window.page = page

var $win
    , $body
    , $wrap
    , $container
    , $content
    , $slider
    , $fullpage
    , $loading
    , $cursor

     // State
    , userData = navigator.userAgent
    , isMoblie = /iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle/i.test(userData)
    , isPad = /iPad/i.test(userData)
    , isPhone = /iP(hone|od)|Android|BlackBerry|IEMobile|Kindle/i.test(userData)
    , isIe = (userData.indexOf('MSIE ') > 0 || !!userData.match(/Trident.*rv\:11\./))
    , isHome = false
    , isSingleProject = false
    , isClickLink = false
    , isInit = true
    , isAnimate = false
    , isAjax = false
    , isChangeHash  = false
    , tabIndex = 0
    , tabTop = 0
    , hasBuild = false
    , cacheIndex = false
    , cache = {}
    , hide_cursor = false
    
    , projects = {
        'url': '',
        'index': 0,
        'items': []
    }

    // Events
    var _es = $({})

    $.subscribe = function() {
        _es.on.apply(_es, arguments)
    }

    $.unsubscribe = function() {
        _es.off.apply(_es, arguments)
    }

    $.publish = function() {
        _es.trigger.apply(_es, arguments)
    }


    // Router
    window.init = {
        ctx: function(ctx, next) {
            ctx.data = {}
            ctx.partials = {}
            next()
        }
    }

    window.render = {
        pages: function(ctx, next) {
            if (isChangeHash) return;
            
            if (!isInit) {
                if (!isAjax) {
                    isAjax = true
                    var url = ctx.canonicalPath + '?ajax=true'
                    if (ctx.canonicalPath.indexOf('?') !== -1) {
                        url = ctx.canonicalPath + '&ajax=true'
                    }

                    get(url, function(html) {
                        
                        update(html, 'ajax')
                        isAjax = false
                        if (typeof done === 'function') done(ctx.data.index)
                    })
                }

            } else {
                update(null, 'init')
            }

            isInit = false
        }
    }

    window.done = null

    // Functions
    function get(url, cb) {
        if (cache[url]) return cb(cache[url])
        $body.addClass('loading')

        $.ajax({
            url: url,
            success: function(data) {
                cache[url] = data;
                cb(data)
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(jqXHR, textStatus, errorThrown);
            },
            dataType: 'text'
        })
    }

    function update(html, type) {
        if (type === 'init') {
            // Init
            $(document).ready(init)
            
        } else {
            // Ajax
            $content = $(html)
            updateClass()
            hanadle($content, true)
        }
    }

    function updateClass() {
        if (typeof $content.data('title') !== 'undefined') {
            $body.attr('class', $content.data('bodyClass'))
            document.title = $content.data('title')
        }
    }

    function hanadle($e) {
        isHome = $body.hasClass('home')
        isSingleProject = $body.hasClass('single-project')

        if (isAjax) {
            velocity($container, 'fadeOut', 150, function() {
                $body.scrollTop(0)
                $container.html($e).css('opacity', 0).show()
                runFuns()
                
                
                velocity($container, 'fadeIn', 150, function() {
                    $body.removeClass('loading')
                    isClickLink = false

                    full()
                })
            })
        }
    }

    function full() {
        if (hasBuild) {
            $.fn.fullpage.destroy('all')
            hasBuild = false
        }

        $fullpage = $('#js-fullpage')

        if ($fullpage.length !== 0) {

            $fullpage.find('.arrow-down').on('click', () => {
                $.fn.fullpage.moveSectionDown()
            })

            $fullpage.find('.arrow-up').on('click', () => {
                $.fn.fullpage.moveSectionUp()
            })
            
            if (hasBuild) $.fn.fullpage.destroy('all')

            if (isPhone) {
                $fullpage.imagesLoaded( function() {
                    $fullpage.fullpage({
                        css3: true,
                        scrollingSpeed: 700,
                        //autoScrolling: true,
                        //fitToSection: true,
                        loopHorizontal: false,
                        scrollOverflow: true,
                        onLeave (index, nextIndex, direction) {
                            $('#js-pagenavi .current').html(nextIndex)
                        }
        
                    })
        
                    hasBuild = true
                })
                  
            } else {
                $fullpage.fullpage({
                    css3: true,
                    scrollingSpeed: 700,
                    //autoScrolling: true,
                    //fitToSection: true,
                    loopHorizontal: false,
                    scrollOverflow: true,
                    onLeave (index, nextIndex, direction) {
                        $('#js-pagenavi .current').html(nextIndex)
                    }
    
                })
    
                hasBuild = true
            }
            

        }
    }
    /*
    function scroll() {
        // var scrollY = (window.scrollY || window.pageYOffset || document.documentElement.scrollTop)
    }

    function scrollTo($e, offset) {
		var o = 0
		
		if ($e.length !== 0) {
			o = $e.offset().top
		

			$('body,html').animate({
				scrollTop: o - offset
			}, 300)
		}
    }
    */

    
   var preColor = 'black'
   var curColor = 'black'
   
    function sideCallback($el) {
        if (isHome) {
            /*
            var color = $el.data('uiColor')

            if (color.indexOf('#fff') !== -1) {
                $body.removeClass('bg-white')
            } else {
                $body.addClass('bg-white')
            }
            */

           

        
            
           if ($el.hasClass('arrow-color-white')) {
                $body.removeClass('bg-white')
                curColor = 'white'
            } else {
                $body.addClass('bg-white')
                curColor = 'black'
            }

            if (preColor !== curColor) {
                //$slider.addClass('hide-arrow')
                preColor = curColor
            }
        }

        else if (isSingleProject) {
            //$slider.addClass('hide-arrow')
            var inx = $el.data('index')
            $('#js-num .current').text(inx)
            
            if (inx === Number($('#js-num .total').text())) {
                $('#js-next-project').addClass('show')
            } else {
                $('#js-next-project').removeClass('show')
            }
        } else {
            //$slider.addClass('hide-arrow')
        }

        
    }


    function slider() {
        $slider = $('#js-slider')

        // var preColor = 'balck'

        if ($slider.length !== 0) {
            $slider.imagesLoaded( function() {
                if ($body.hasClass('page-template-template-Project-category')) {
                    $slider.find('img').hide().show();
                }
            })

            $slider.on('init', function(event, slick){
                sideCallback($(this).find('.slick-active .item'))
                //$slider.removeClass('hide-arrow')

                if ($(this).find('.slick-active .item').hasClass('video')) {
                    $(this).find('.slick-active video')[0].play()
                }

                setTimeout(() => {


                    if ((isHome || $body.hasClass('page-template-template-Project-category')) && projects.index !== 0 && cacheIndex) {
                        $slider.slick('slickGoTo', projects.index)
                        cacheIndex = false
                        projects.index = 0
                    }


                }, 500)
            })

            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                sideCallback($(this).find('[data-slick-index="'+ nextSlide +'"]  .item'))

                if ($(this).find('.slick-active .item').hasClass('video')) {
                    $(this).find('.slick-active video')[0].pause()
                }
            })

            $slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
                //$slider.removeClass('hide-arrow')

                if ($(this).find('.slick-active .item').hasClass('video')) {
                    $(this).find('.slick-active video')[0].play()
                }
            })

            $slider.slick({
                adaptiveHeight: true,
                fade: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                arrows: false,
                cssEase: 'ease',
                infinite: isHome
            })

            $slider.mw(function( dir, target ) {
                $cursor.removeClass('show')
                hide_cursor = true

                setTimeout(() => {
                    hide_cursor = false 
                }, 500)

                switch ( dir ) {
                    case 'left' :
                    case 'up' :
                        $slider.slick('slickPrev')

                        break;
                    case 'right' :
                    case 'down' :
                        $slider.slick('slickNext')
                        
                        break;
                }
            })

            $slider.find('.next').on('click', function() {
                $slider.slick('slickNext')
            }) 

            $slider.find('.prev').on('click', function() {
                $slider.slick('slickPrev')
            })

    



            if (isSingleProject) {
                var inx = 0
                var current = $slider.data('url')
                var nextProject = false

                if (projects.items.length !== 0) {
                    projects.items.forEach((item, index) => {
                        // console.log(index, item)
                        if (current === item.url) {
                            if (typeof projects.items[index + 1] !== 'undefined') {
                                nextProject = projects.items[index + 1]
                            } else {
                                $('#js-next-project').text('Back')
                            }
                        }
                    })
                } else {
                    $('#js-next-project').text('Back')
                }

                $('#js-next-project').on('click', function() {
                    if (nextProject) {
                        page(nextProject.url)
                    } else {
                        page(projects.url)
                    }
                })

                $('#js-back').on('click', function() {
                    page(projects.url)
                })
            }
        }
    }
    
    

    function runFuns() {
        if ($body.hasClass('page-archive')) {
            if (tabIndex !== 0) {
                $('#js-tabs .current').removeClass('current')
                $('#js-tabs li').eq(tabIndex).addClass('current')
                $('#js-tabs-body .show').removeClass('show').hide()
                $('#js-tabs-body .tab-content').eq(tabIndex).addClass('show').show()
            }
    
            if (tabTop !== 0) {
                 $('#js-tabs-body')[0].scrollTop = tabTop
            }
        }

        if (!(isPhone && $body.hasClass('page-template-template-Project-category'))) slider()
    }

    function bindEvents() {
        //scroll()
        //$win.on('scroll', scroll)


        $body
            .on('click', 'a', function() {
                isChangeHash = false
            })

            .on('click', '#js-header a', function(e) {
                projects.index = 0
                cacheIndex = false
            })

            .on('mousemove', '.next,.prev', function(e) {
                moveCursor(e)
            })

            .on('mouseover', '#js-slider .next,#js-slider .prev', function() {
                if ($(this).hasClass('prev')) {
                    $cursor.attr('data-arrow', 'left')
                } else {
                    $cursor.attr('data-arrow', 'right')
                }


                if (!hide_cursor && !isMoblie) $cursor.addClass('show')
            })

            .on('mouseout', '#js-slider .next,#js-slider .prev', function() {
                $cursor.removeClass('show')
            })

            .on('contextmenu', '#js-slider .next,#js-slider .prev', function(ev) {
                $cursor.removeClass('show')
            })

            
            .on('click', '.js-open-sidemenu > a', function(e) {
                isChangeHash = true

               var hash = $(this).attr('href').split('#')[1]

                if (hash === 'js-stories') {
                    if ($body.hasClass('show-stories')) {
                        $body.removeClass('show-stories')
                    } else {
                        $body.removeClass('show-projects').addClass('show-stories')
                    }
                } else {
                    if ($body.hasClass('show-projects')) {
                        $body.removeClass('show-projects')
                    } else {
                        $body.removeClass('show-stories').addClass('show-projects')
                    }
                }

                // history.pushState(null, null, '#')
                // history.pushState(null, null, ('#' + hash))

                e.preventDefault()
                
            })

            .on('click', '.menus a', function() {
                $('.menus .show').removeClass('show')
            })

            .on('click', '.project-header .title', function(ev) {
                $slider.slick('slickGoTo', 0)
            })


            .on('mouseleave', '.menus a', function() {
                $(this).removeClass('show')
            })

            .on('mouseenter', '.menus a', function() {
                $(this).addClass('show')
            })

            .on('click touchstart', '.js-close-menu', function() {
                isChangeHash = false
                $body.removeClass('show-projects show-stories')
            })

            .on('click', '#js-tabs li', function(e) {
                e.preventDefault()

                if (!$(this).hasClass('current')) {
                    $('#js-tabs .current').removeClass('current')
                    $(this).addClass('current')
                    var index = $(this).index()

                    tabIndex = index

                    velocity($('#js-tabs-body .show').removeClass('show'), 'fadeOut', 100, function() {
                        velocity($('#js-tabs-body .tab-content').eq(index).addClass('show'), 'fadeIn', 100)
                    })
                }
            })

            .on('click', '#js-tabs-body .after a', function(e) {
                tabTop = $('#js-tabs-body')[0].scrollTop
            })

            .on('click', '.home-slider .project-title', function() {
                projects.url = window.location.href
                projects.items = []
                projects.index = $slider.find('.slick-current').data('slickIndex')
                cacheIndex = true

                $('#js-slider .slick-slide').not('.slick-cloned').each((index, item) => {
                    var url = $(item).find('.project-title').attr('href')

                    if (url.indexOf('/project/') !== -1) {
                        projects.items.push({
                            url: url,
                            title: $(item).find('.project-title').text()
                        })
                    }
                })

                //console.log(projects)
            })

            .on('click', '.selected-slider .image-item', function() {
                projects.url = window.location.href
                projects.items = []
                projects.index = $slider.find('.slick-current').data('slickIndex')
                cacheIndex = true

                $('#js-slider .image-item').each((index, item) => {
                    var url = $(item).attr('href')
                    

                    if (url.indexOf('/project/') !== -1) {
                        projects.items.push({
                            url: url,
                            title: $(item).find('.project-title').text()
                        })
                    }
                })

                //console.log(projects)
            })

            .on('click', '#js-tabs-body .after a', function() {
                projects.url = window.location.href
                projects.items = []
                projects.index = 0
                cacheIndex = false

                $('#js-tabs-body .tab-content').eq(tabIndex).find('.after').each((index, item) => {
                    var $el = $(item).find('a').eq(0)
                    var url = $el.attr('href')

                    if (url.indexOf('/project/') !== -1) {
                        projects.items.push({
                            url: url,
                            title: $el.text()
                        })
                    }
                })

                //console.log(projects)
            })
            
            $(document).on( 'keydown', function(e) {
                if ($slider.length !== 0) {
                    $cursor.removeClass('show')
                    hide_cursor = true

                    setTimeout(() => {
                        hide_cursor = false 
                    }, 500)

                    if ( e.keyCode == 37 ) {
                        $slider.slick('slickPrev')
                    } else if (e.keyCode == 39 ) {
                        $slider.slick('slickNext')
                    }
    
                    else if (e.keyCode == 27) {
                        if ($body.hasClass('single-project')) {
                            $('#js-back').click()
                        }
                    }
                }



            })
    }


    function moveCursor(e) {
        // console.log(e)
        var x = (e.clientX - 20),
            y = (e.clientY - 20)

        $cursor[0].setAttribute('style', 'transform: translate(' + x + 'px, ' + y + 'px)')
    }

    function init() {
        $win = $(window)
        $body = $('body')

        isHome = $body.hasClass('home')
        isSingleProject = $body.hasClass('single-project')

        $container = $('#container')
        $wrap = $('#wrap')
        $content = $body
        $cursor = $('#js-cursor')

        if (isIe) $('html').addClass('is-ie')
        projects.url = window.globals.home_url

        bindEvents()
        runFuns()
        full()

        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
    }

    $.fn.mw = function( callback ) {

        window.isMouseWheeling = false;
        var eventName = 'mousewheel'
        if ( /firefox/.test(navigator.userAgent.toLowerCase()) )
            eventName = 'DOMMouseScroll'
        if ( /safari/.test(navigator.userAgent.toLowerCase()) )
            eventName = 'mousewheel'
        
        $(this).on( eventName, function(e) {
    
            // constants
            if ( /macintosh/.test(navigator.userAgent.toLowerCase()) ) {
                // mac
                var offsetH = 170,
                    offsetV = 150,
                    delay   = 600
            }

            if ( /windows/.test(navigator.userAgent.toLowerCase()) ) {
                // win
                var offsetH = 100,
                    offsetV = 100,
                    delay   = 600
            }
    
            // retrieve length
            var deltaX = e.originalEvent.wheelDeltaX,
                deltaY = e.originalEvent.wheelDeltaY

            if ( /firefox/.test(navigator.userAgent.toLowerCase()) ) {
                if ( e.originalEvent.HORIZONTAL_AXIS === e.originalEvent.axis ) {
                    var deltaX = e.originalEvent.mozMovementX * ( e.originalEvent.detail < 0 ? 1 : -1 ),
                        deltaY = 0;
                } else {
                    var deltaX = 0,
                        deltaY = e.originalEvent.mozMovementY * ( e.originalEvent.detail < 0 ? 1 : -1 )
                }
            }

            if ( 'undefined' !== typeof e.originalEvent.wheelDelta ) {
                var deltaX = 0,
                    deltaY = e.originalEvent.wheelDelta;
            }
    
            if ( ! isMouseWheeling && ( Math.abs( deltaX ) >= offsetH || Math.abs( deltaY ) >= offsetV ) ) {
                isMouseWheeling = true

                if ( Math.abs( deltaX ) >= offsetH ) {
                    if ( deltaX >= offsetH ) {
                        callback( 'left', this )
                    }
                    if ( deltaX <= -offsetH ) {
                        callback( 'right', this )
                    }
                }

                if ( Math.abs( deltaY ) >= offsetV ) {
                    if ( deltaY >= offsetV ) {
                        callback( 'up', this )
                    }
                    if ( deltaY <= -offsetV ) {
                        callback( 'down', this )
                    }
                }

                // delay triggering event
                setTimeout( function() {
                    isMouseWheeling = false
                }, delay )
            } else {
                // do nothing
            }
    
        })
    
    }